import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'grabbitbot-legacy-ui/style.css'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('root element missing')

async function start() {
  // Dev/E2E only: VITE_MOCK_API=1 swaps the network for the in-browser fixture
  // backend. The import is dead-code-eliminated from a normal build.
  if (import.meta.env.VITE_MOCK_API === '1') {
    const { installMockBackend } = await import('./mocks/installMock')
    installMockBackend()
  }
  const { App } = await import('./App')
  createRoot(root!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
